/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { CLOUD_ARTIFACTS_CONFIG } from '@/config/embeddedApps';
import { useEmbeddedApp } from '@/hooks/useEmbeddedApp';

export function CloudArtifactsPage() {
  const { iframeRef, iframeSrc } = useEmbeddedApp(CLOUD_ARTIFACTS_CONFIG);

  return (
    <iframe
      ref={iframeRef}
      src={iframeSrc}
      allow="clipboard-read; clipboard-write; downloads"
      style={{
        width: '100%',
        flex: 1,
        border: 'none',
      }}
      title="Cloud Artifacts"
    />
  );
}
